// extracted by mini-css-extract-plugin
export default {"mainContainer":"LayoutDashboardUserPage_mainContainer__IKBxL"};